﻿define(
({
	buttonOk: "ठीक है",
	buttonCancel: "रद्द करें",
	buttonSave: "सहेजें",
	itemClose: "बंद करें"
})
);
